import { Base, Component, Prop, VueTsx } from '@/vue-property-decorator'
import { createPngSprite } from '@/utils/business-utils/assets'
import { useMainStore } from '@/store/index'
import AppTypes from '@/vue-types'
import style from './style.module.scss'

export interface Props {
  /**
   * 按钮点击事件
   */
  close?: () => void
}

@Component<ModalCloseIcon>({
  name: 'ModalCloseIcon'
})
export default class ModalCloseIcon extends Base<unknown, Props> {
  @Prop(AppTypes.func.def(() => null))
  private readonly close!: NonNullable<Props['close']>

  render() {
    const { isWeb } = useMainStore()

    return (
      <div
        class={style.closeIcon}
        onClick={VueTsx.modifiers.stop(() => {
          this.close()
        })}
        v-show={!isWeb}
      >
        <icon-sprite
          sprite={createPngSprite('sprite_main_img_close_s2')}
          scale={0.68}
          useSkeleton
        />
      </div>
    )
  }
}
